export { TextInput } from "@mantine/core";
export type { TextInputProps } from "@mantine/core";
export { getTextInputOverrides } from "./TextInput.styled";
